import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PillarVenn } from "./Graphics";
import { PILLARS } from "./content";

const EASE = [0.16, 1, 0.3, 1];

export default function FormulaReveal() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const letterSpacing = useTransform(scrollYProgress, [0.1, 0.5], ["0.5em", "0.12em"]);
  const opacity = useTransform(scrollYProgress, [0.05, 0.3], [0, 1]);

  return (
    <section
      id="the-system"
      ref={ref}
      data-testid="formula-reveal-section"
      className="relative overflow-hidden bg-forest py-32 text-warm md:py-48"
    >
      <div className="mx-auto max-w-[1600px] px-6 text-center md:px-12">
        <motion.span
          style={{ opacity }}
          className="overline text-champagne"
        >
          The Reveal
        </motion.span>

        <motion.h2
          style={{ letterSpacing }}
          className="mx-auto mt-10 font-serif text-[2rem] font-light uppercase leading-[1.05] sm:text-5xl lg:text-[5rem]"
        >
          The Luxury Legacy
          <br />
          Villa Formula
        </motion.h2>

        <div className="mx-auto mt-14 flex max-w-2xl flex-col items-center md:mt-16">
          <PillarVenn className="h-[300px] w-[360px] text-champagne md:h-[340px] md:w-[420px]" />

          <div className="mt-10 grid w-full grid-cols-3 gap-px overflow-hidden border border-warm/15">
            {PILLARS.map((p, i) => (
              <motion.div
                key={p}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.8, ease: EASE, delay: 0.15 * i }}
                className="border-warm/15 px-3 py-6 text-center sm:border-l first:border-l-0"
              >
                <span className="font-serif text-xs text-champagne">0{i + 1}</span>
                <p className="mt-2 font-serif text-xl italic md:text-2xl">{p}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
